/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.studio.backend.rpc.assetconfiguration.AssetConfigurationService
 */

export const getAllAssetConfigurationsRpc = {
  serviceName: 'com.hubspot.studio.backend.rpc.assetconfiguration.AssetConfigurationService',
  rpcName: 'getAllAssetConfigurations',
  auth: 'app',
  fingerprint: '93IT4gC4oIF7zo1-r2Hxl6Ye-OGaphEG',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};